import _VocabularyResult from './model';

export const VocabularyResult = _VocabularyResult;

export default VocabularyResult;



// WEBPACK FOOTER //
// ./data/Vocabulary/VocabularyResult/index.js